import React, { Component } from 'react'
import { DatePicker, List, Tabs, WhiteSpace, Toast } from 'antd-mobile'
import df from 'dateformat'
import { ROOT_PATH } from '../../config'
import send from '../../utils/send'
import Table from '../../components/Table'
import EmptyReport from '../../components/EmptyReport'
import { ORG_CODE, FARM_ORG } from '../../cache'

const today = new Date();
let clientWidth = document.documentElement.clientWidth;
let clientHeight = document.documentElement.clientHeight - 100;
let already = 0;

const tabs = [
  { title: '配种分娩断奶' },
  { title: '保育育成' },
  { title: '销售' },
  { title: '采购' }
];

const order = [
  '后备母猪数量',
  '-后备母猪入群数',
  '-后备母猪死亡数量',
  '-后备母猪淘汰数量',
  '生产母猪数量',
  '非生产母猪数',
  '-空怀',
  '-流产',
  '-返情',
  '死亡母猪数',
  '淘汰母猪数',
  '配种目标',
  '配种数量',
  '分娩母猪窝数',
  '分娩总仔数',
  '窝产总仔数',
  '-死胎',
  '-木乃伊',
  '-畸形',
  '-弱仔',
  '-压死',
  '窝均死、黑、木胎',
  '总健仔数',
  '窝均健仔数',
  '断奶母猪数',
  '断奶仔猪总数（按母猪断奶记录）',
  '窝均断奶数（按母猪断奶记录）',
  '窝均断奶重（KG）',
  '转移仔猪数',
  '销售仔猪数',
  '死淘仔猪数',
  '-死亡',
  '-淘汰',
  '产房损失率',
  '仔猪存栏'
];

const typeOrder = ['数量', '重量', '金额'];

class Daily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: today,
      hasBreedData: true,
      hasNurseData: true,
      hasCradleData: true,
      hasSellData: true,
      hasPurchaseData: true,
      data_breed: [],
      data_nurse: [],
      data_cradle: [],
      data_sell: [],
      table_purchase: [],
      columns_breed: [
        { id: 'name', title: '配种分娩断奶', align: 'left', width: '150' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' }
      ],
      columns_nurse: [
        { id: 'name', title: '保育', align: 'left', width: '150' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' }
      ],
      columns_cradle: [
        { id: 'name', title: '育成', align: 'left', width: '150' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' }
      ],
      columns_sell: [
        {
          id: 'name',
          title: '销售明细',
          align: 'left',
          width: '90',
          fixed: true
        },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_50: [
        { id: 'name', title: '种猪', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_21: [
        { id: 'name', title: '药品', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_22: [
        { id: 'name', title: '疫苗', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_51: [
        { id: 'name', title: '肥猪', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_52: [
        { id: 'name', title: '猪苗', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_10: [
        { id: 'name', title: '饲料', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ],
      columns_purchase_23: [
        { id: 'name', title: '其他', align: 'left', width: '90', fixed: true },
        { id: 'item', title: '项目', align: 'right' },
        { id: 'today', title: '当天', align: 'right' },
        { id: 'total_month', title: '本月累计', align: 'right' },
        { id: 'last_month', title: '上月同期', align: 'right' },
        { id: 'total_year', title: '本年累计', align: 'right' }
      ]
    }
  }

  // 获取 配种分娩
  getBreedTableData(date) {
    send(`${ROOT_PATH}/api/ifarm/v1/daily_report/product`, {
      method: 'POST',
      data: {
        date: date,
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE
      }
    })
      .then(res => {
        already++;
        this.updateBreedTable(res.data.data)
      })
      .catch(execption => {
        return execption
      })
  }

  updateBreedTable(data) {
    if (!data || data.length === 0) {
      this.setState({ hasBreedData: false });
      return
    }
    this.setState({ hasBreedData: true });

    let dataSource = [];
    data.map(obj => {
      let newObj = {};
      let name = obj.detailNameLoc.replace(new RegExp(' ', 'g'), '');
      newObj['name'] = name;
      newObj['today'] = obj.valToday !== undefined ? obj.valToday : '-';
      newObj['total_month'] = obj.valMonth !== undefined ? obj.valMonth : '-';
      dataSource.push(newObj)
    });

    dataSource.sort((obj1, obj2) => {
      const name1 = obj1.name;
      const name2 = obj2.name;
      let index1 = order.indexOf(name1);
      let index2 = order.indexOf(name2);
      return index1 - index2
    });

    this.setState({ data_breed: dataSource })
  }

  // 获取 保育
  getNurseTableData(date) {
    send(`${ROOT_PATH}/api/ifarm/v1/daily_report/nursery`, {
      method: 'POST',
      data: {
        date: date,
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE
      }
    })
      .then(res => {
        already++;
        this.updateNurseTable(res.data.data)
      })
      .catch(execption => {
        return execption
      })
  }
  updateNurseTable(data) {
    if (!data || data.length === 0) {
      this.setState({ hasNurseData: false });
      return
    }
    this.setState({ hasNurseData: true });

    let dataSource = [];
    data.map(obj => {
      let newObj = {};
      let name = obj.detailNameLoc.replace(new RegExp(' ', 'g'), '');
      newObj['name'] = name;
      newObj['today'] = obj.valToday !== undefined ? obj.valToday : '-';
      newObj['total_month'] = obj.valMonth !== undefined ? obj.valMonth : '-';
      dataSource.push(newObj)
    });
    this.setState({ data_nurse: dataSource })
  }

  // 获取 育成
  getCradleTableData(date) {
    send(`${ROOT_PATH}/api/ifarm/v1/daily_report/finish`, {
      method: 'POST',
      data: {
        date: date,
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE
      }
    })
      .then(res => {
        already++;
        this.updateCradleTable(res.data.data)
      })
      .catch(execption => {
        return execption
      })
  }
  updateCradleTable(data) {
    if (!data || data.length === 0) {
      this.setState({ hasCradleData: false });
      return
    }
    this.setState({ hasCradleData: true });

    let dataSource = [];
    data.map(obj => {
      let newObj = {};
      let name = obj.detailNameLoc.replace(new RegExp(' ', 'g'), '');
      if (name.indexOf('损失率') !== -1) {
        return
      }
      newObj['name'] = name;
      newObj['today'] = obj.valToday !== undefined ? obj.valToday : '-';
      newObj['total_month'] = obj.valMonth !== undefined ? obj.valMonth : '-';
      dataSource.push(newObj)
    });
    this.setState({ data_cradle: dataSource })
  }

  // 获取 销售
  getSellTableData(date) {
    send(`${ROOT_PATH}/api/ifarm/v1/daily_report/sale`, {
      method: 'POST',
      data: {
        date: date,
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE
      }
    })
      .then(res => {
        already++;
        this.updateSellTable(res.data)
      })
      .catch(execption => {
        return execption
      })
  }

  updateSellTable(data) {
    let results = [];
    results = data.data;

    if (!results || results.length === 0) {
      this.setState({ hasSellData: false });
      return
    }
    this.setState({ hasSellData: true });

    let dataSource = [];
    let preName = '';
    // 排序
    results.sort((a, b) => {
      const name1 = a.valTypeNameLoc;
      const name2 = b.valTypeNameLoc;
      let index1 = typeOrder.indexOf(name1);
      let index2 = typeOrder.indexOf(name2);
      return index1 - index2
    });

    results.sort((a, b) => {
      return parseInt(a.detailCode) - parseInt(b.detailCode)
    });

    // 计算跨行数
    let rowSpanObj = {};
    results.map(obj => {
      let name = obj.detailNameLoc;
      let value = rowSpanObj[name];
      if (value === undefined) {
        rowSpanObj[name] = 1
      } else {
        rowSpanObj[name] = value + 1
      }
    });

    results.map(obj => {
      let newObj = {};
      let name = obj.detailNameLoc;
      if (preName === '' || preName != name) {
        let nameObj = {
          text: name,
          rowSpan: rowSpanObj[obj.detailNameLoc]
        };
        newObj['name'] = nameObj;
        preName = name
      }

      newObj['item'] = obj.valTypeNameLoc;
      newObj['today'] = obj.valToday !== undefined ? obj.valToday : '-';
      newObj['total_month'] = obj.valMonth !== undefined ? obj.valMonth : '-';
      newObj['last_month'] =
        obj.mmPrevTodayVal !== undefined ? obj.mmPrevTodayVal : '-';
      newObj['total_year'] = obj.yearAccVal !== undefined ? obj.yearAccVal : '-';
      dataSource.push(newObj)
    });

    this.setState({ data_sell: dataSource })
  }

  // 获取 采购
  getPurchaseTableData(date) {
    this.setState({ table_purchase: [] });

    send(`${ROOT_PATH}/api/ifarm/v1/daily_report/purchase`, {
      method: 'POST',
      data: {
        date: date,
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE
      }
    })
      .then(res => {
        already++;
        this.updatePurchaseTable(res.data)
      })
      .catch(execption => {
        return execption
      })
  }

  updatePurchaseTable(data) {
    let results = data.data;

    if (!results || results.length === 0) {
      this.setState({ hasPurchaseData: false });
      return
    }
    this.setState({ hasPurchaseData: true });

    // 根据库存类型进行数据拆分
    let dataSource10 = [];
    let dataSource21 = [];
    let dataSource22 = [];
    let dataSource23 = [];
    let dataSource50 = [];
    let dataSource51 = [];
    let dataSource52 = [];
    results.map(obj => {
      switch (obj.stockType) {
        case 10:
          dataSource10.push(obj);
          break;
        case 21:
          dataSource21.push(obj);
          break;
        case 22:
          dataSource22.push(obj);
          break;
        case 23:
          dataSource23.push(obj);
          break;
        case 50:
          dataSource50.push(obj);
          break;
        case 51:
          dataSource51.push(obj);
          break;
        case 52:
          dataSource52.push(obj);
          break;
        default:
          break
      }
    });

    this.updatePurchaseData(50, dataSource50);
    this.updatePurchaseData(51, dataSource51);
    this.updatePurchaseData(52, dataSource52);
    this.updatePurchaseData(10, dataSource10);
    this.updatePurchaseData(21, dataSource21);
    this.updatePurchaseData(22, dataSource22);
    this.updatePurchaseData(23, dataSource23)
  }

  updatePurchaseData(type, results) {
    let dataSource = [];
    let preName = '';

    // 排序
    results.sort((a, b) => {
      const name1 = a.valTypeNameLoc;
      const name2 = b.valTypeNameLoc;
      let index1 = typeOrder.indexOf(name1);
      let index2 = typeOrder.indexOf(name2);
      return index1 - index2
    });

    results.sort((a, b) => {
      return parseInt(a.detailCode) - parseInt(b.detailCode)
    });

    // 计算跨行数
    let rowSpanObj = {};
    results.map(obj => {
      let name = obj.detailNameLoc;
      let value = rowSpanObj[name];
      if (value === undefined) {
        rowSpanObj[name] = 1
      } else {
        rowSpanObj[name] = value + 1
      }
    });

    results.map(obj => {
      let newObj = {};
      if (preName === '' || preName != obj.detailNameLoc) {
        let nameObj = {
          text: obj.detailNameLoc,
          rowSpan: rowSpanObj[obj.detailNameLoc]
        };
        newObj['name'] = nameObj;
        preName = obj.detailNameLoc
      }
      // 库存类型（21:药品，22:疫苗，23:其他，50:种猪，51：肥猪,52：猪苗，10：饲料）
      newObj['item'] = obj.valTypeNameLoc;
      newObj['today'] = obj.valToday !== undefined ? obj.valToday : '-';
      newObj['total_month'] = obj.valMonth !== undefined ? obj.valMonth : '-';
      newObj['last_month'] =
        obj.mmPrevTodayVal !== undefined ? obj.mmPrevTodayVal : '-';
      newObj['total_year'] = obj.yearAccVal !== undefined ? obj.yearAccVal : '-';
      dataSource.push(newObj)
    });

    switch (type) {
      case 50: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_50
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      case 51: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_51
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      case 52: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_52
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      case 10: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_10
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      case 21: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_21
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      case 22: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_22
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      case 23: {
        if (dataSource.length > 0) {
          let tables = this.state.table_purchase;
          let obj = {
            data: dataSource,
            columns: this.state.columns_purchase_23
          };
          if (tables.indexOf(obj) === -1) {
            tables.push(obj)
          }
          this.setState({ table_purchase: tables })
        }
        break
      }
      default:
        break
    }
  }

  doSearch = date => {
    already = 0;
    Toast.loading('加载中...', 0);

    var d = df(date || new Date(), 'yyyy-mm-dd');
    this.getBreedTableData(d);
    this.getNurseTableData(d);
    this.getCradleTableData(d);
    this.getSellTableData(d);
    this.getPurchaseTableData(d)
  };

  componentDidMount() {
    window._czc && window._czc.push(['_trackEvent', '进入日报页面']);
    this.doSearch()
  }

  componentDidUpdate() {
    if (already === 5) {
      Toast.hide()
    }
  }

  componentWillUnmount() {
    Toast.hide();
    this.setState = () => {

    }
  }

  render() {
    return (
      <React.Fragment>
        <DatePicker
          extra="Optional"
          mode="date"
          maxDate={today}
          onChange={date => {
            this.setState({ date });
            this.doSearch(date)
          }}
          title="日期"
          value={this.state.date}
        >
          <List.Item arrow="horizontal">选择日期</List.Item>
        </DatePicker>
        <List renderHeader={() => ''}>
          <Tabs
            tabs={tabs}
            initialPage={0}
            animated={false}
            useOnPan={false}
            swipeable={false}
            tabBarTextStyle={{ fontSize: 12 }}
          >
            <div>
              {this.state.hasBreedData ? (
                <Table
                  columns={this.state.columns_breed}
                  data={this.state.data_breed}
                />
              ) : (
                <EmptyReport height={clientHeight} width={clientWidth} />
              )}
            </div>
            <div>
              {this.state.hasNurseData && this.state.hasCradleData ? (
                <div>
                  <Table
                    columns={this.state.columns_nurse}
                    data={this.state.data_nurse}
                  />
                  <Table
                    columns={this.state.columns_cradle}
                    data={this.state.data_cradle}
                  />
                </div>
              ) : this.state.hasNurseData && !this.state.hasCradleData ? (
                <Table
                  columns={this.state.columns_nurse}
                  data={this.state.data_nurse}
                />
              ) : !this.state.hasNurseData && this.state.hasCradleData ? (
                <Table
                  columns={this.state.columns_cradle}
                  data={this.state.data_cradle}
                />
              ) : (
                <EmptyReport height={clientHeight} width={clientWidth} />
              )}
            </div>
            <div>
              {this.state.hasSellData ? (
                <Table
                  columns={this.state.columns_sell}
                  data={this.state.data_sell}
                />
              ) : (
                <EmptyReport height={clientHeight} width={clientWidth} />
              )}
            </div>
            <div>
              {!this.state.hasPurchaseData ? (
                <EmptyReport height={clientHeight} width={clientWidth} />
              ) : (
                <div>
                  {this.state.table_purchase.map((obj, index) => {
                    return (
                      <Table
                        columns={obj.columns}
                        data={obj.data}
                        key={index + 1}
                      />
                    )
                  })}
                </div>
              )}
            </div>
          </Tabs>
        </List>
        <WhiteSpace size="xl" />
      </React.Fragment>
    )
  }
}

export default Daily
